import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {Col, Row} from 'react-bootstrap';
import Label from 'reactstrap/lib/Label';
import {t} from 'react-switch-lang';
import InputText from '../../../../components/FormFields/InputText';
import FileUploadSection from '../../../../components/FileUploadSection/FileUploadSection';
import allowedFileTypes from '../../../../utils/allowedFileTypes';
import {yupResolver} from '@hookform/resolvers';
import * as yup from 'yup';
import {validNameandNumberEngMneRegex} from '../../../../utils/const';
import Toast from '../../../../components/toast/Toast';
import {
  updateExternalizationDocumentTemplates, getExternalizationFile
} from '../../../../services/externalizations/externalizationTemplatesServices';
import {downloadFile} from "../../../../services/externalizations/fileUploadService";

const PreviewExternalizationTemplates = (props) => {
  const [files, setFiles] = useState(props?.data);
  const [isUploading, setIsUploading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const schema = yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameandNumberEngMneRegex, t('message.fieldNotValid'))
      .max(100, `${t('message.max', {max: 100})}`)
      .min(3, `${t('message.min', {min: 3})}`),
    nameEn: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameandNumberEngMneRegex, t('message.fieldNotValid'))
      .max(100, `${t('message.max', {max: 100})}`)
      .min(3, `${t('message.min', {min: 3})}`),
    template: yup
        .mixed()
        .test('fileRequired', t('message.fieldRequired'), value => {
          if (!files) return false;

          if (typeof files === 'object' && !Array.isArray(files)) {
            return !!files;
          }

          if (Array.isArray(files)) {
            return files.length > 0;
          }

          return false;
        }),
  });
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch,clearErrors, errors, register, setValue} = methods;

  const convertFileObjectToFile = async (fileObj) => {
    try {
      const response = await getExternalizationFile(fileObj.id,fileObj.fileName);
      return new File([response.data], fileObj.fileName, {type: response.data.type});
    } catch (error) {
      console.error("error file conversion:", error);
      return null;
    }
  };

  const submitForm = async (data) => {
    setIsButtonDisabled(true);
    const formData = new FormData();
    formData.append('externalizationDocumentTemplateDTO', JSON.stringify({
      name: data.name,
      nameEn: data.nameEn,
      id: props?.data?.id
    }));

    const file = await convertFileObjectToFile(files.template);
    if (file && !data.file[0]) {
      formData.append('templateFile', file);
    }else {
      formData.append('templateFile', data.file[0]);
    }

    updateExternalizationDocumentTemplates(props?.data?.id,formData).then(async (res) => {
      Toast.fire({
        icon: 'success', title: `${t('message.successEdit')}`,
      });

      await props.fetchData()
      props.toggleModal();
      setFiles();
      setValue('name', '');
      setValue('nameEn', '');
      setValue('template', null);
      setIsButtonDisabled(false);

    }).catch((err) => {
      setIsButtonDisabled(false);
    })
  };


  const handleCancel = e => {
    e.preventDefault();
    props.toggleModal();
    props.setDisabled();
  };
  useEffect(() => {
    return () => {
      props.setDisabled();
    };
  }, []);
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="name"> {t("departments.name")}</Label>
            <InputText
              type="text"
              id="name"
              name="name"
              className={
                "form-control " +
                (errors.name !== undefined ? "error-field" : "")
              }
              disabled={props.disabled}
              placeholder={t("departments.placeholder.name")}
              defaultValue={props?.data?.name}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="nameEn"> {t("departments.nameEn")}</Label>
            <InputText
              type="text"
              id="nameEn"
              name="nameEn"
              className={
                "form-control " +
                (errors.nameEn !== undefined ? "error-field" : "")
              }
              disabled={props.disabled}
              defaultValue={props?.data?.nameEn}
              placeholder={t("departments.placeholder.nameEn")}
            />

          </Col>
          <Col sm={12}>
            <label style={{minHeight: '50px'}} className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
            </label>
            <FileUploadSection
              className={'template'}
              allowedFileTypes={allowedFileTypes}
              multiple={false}
              isUploading={isUploading}
              fetchedFiles={files?.template ? [{ id: files?.template?.id, fileName: files?.template?.fileName }] : []}
              disabled={props.disabled}
              onDeleteFetchedFile={(e) => {
                setFiles(undefined);
                setValue('template', null);
              }}
              onNewFilesChange={(file) => {
                setIsUploading(true)
                clearErrors('template')
                setFiles(file);
                setValue('template', file);
                setIsUploading(false);
              }}
              onFileDownload={(id,name) => {
                downloadFile(id,name);
              }}
              fieldName="template"
              setValue={setValue}
              register={register}
              error={errors?.template?.message}
            />
          </Col>
        </Row>
        {!props.disabled && (
        <Row className="submit-buttons-container mx-0">
          <Col sm={12} className="text-right px-0">
            <div className="submit">
              <button
                className="primary cancel"
                type="reset"
                onClick={(e) => handleCancel(e)}>
                {t("buttons.cancelBtn")}
              </button>
              <button className="primary">
                {(isUploading || isButtonDisabled) ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-2" />
                    {t("buttons.saveBtn")}
                  </>
                ) : (
                  t("buttons.saveBtn")
                )}
              </button>
            </div>
          </Col>
        </Row>)}
      </form>
    </FormProvider>
  );
};

export default PreviewExternalizationTemplates;